// Dependencies
import Page from '../src/components/page/Page';
import React from 'react';

import ContactForm from '../src/components/contact-form/ContactForm';
import ContactUs from '../src/components/contact-us/ContactUs';
// Helpers

const ContactPage = () => (
	<Page>
		<ContactForm />
		<ContactUs title="Other contact options" />
	</Page>
);

export default ContactPage;
